/**
 * Quick add mobile.
 *
 * Un único drawer inferior, compartido por todas las product cards, que se
 * llena leyendo la card que disparó el "+". Clonar el markup de talles en el
 * momento de abrir resuelve solo el requisito de mostrar los talles del color
 * activo: ColorSwatch.updateSizes() ya reemplaza el [data-sizes-overflow] de la
 * card cada vez que se toca un swatch.
 */
class QuickAddDrawer extends DrawerComponent {
  constructor() {
    super();

    this.selectors = {
      title: '[data-quick-add-title]',
      price: '[data-quick-add-price]',
      sizes: '[data-quick-add-sizes]',
      cardTitle: '.product-card__title .reversed-link__text',
      cardPrice: '.f-price',
      cardSizes: '[data-sizes-overflow]',
      hiddenSize: '[data-sizes-hidden]',
      moreToggle: '[data-sizes-toggle]',
      sizeButton: '.sizes-container__btn',
    };
  }

  connectedCallback() {
    super.connectedCallback();

    this.addEventListener('click', this.onSizeClick.bind(this), {
      signal: this.abortController.signal,
    });
  }

  onSizeClick(event) {
    if (!event.target.closest(this.selectors.sizeButton)) return;

    // simpleAddToCart dispara cart:refresh recién cuando termina el fetch:
    // cerramos ahí para que el cart drawer tome la pantalla con el item ya
    // agregado. Solo un error de red corta el evento y deja el drawer abierto;
    // simpleAddToCart no chequea res.ok, así que un 4xx igual cierra.
    document.addEventListener('cart:refresh', () => this.hide(), { once: true });
  }

  /**
   * Copia título, precio y talles de la card al drawer.
   * @param {HTMLElement} card
   * @returns {boolean} false cuando la card no tiene talles que clonar (ajuste
   * pcard_choose_options_actions distinto de display_sizes), para que el
   * llamador caiga a la PDP.
   */
  populate(card) {
    const cardSizes = card.querySelector(this.selectors.cardSizes);
    if (!cardSizes) return false;

    const sizes = cardSizes.cloneNode(true);

    // El contenedor original trae .product-card__atc y
    // .product-card__action-button, que en mobile lo fuerzan a 3.8rem y
    // border-radius 50%. En el drawer solo queremos la grilla de chips.
    sizes.className = 'sizes-container quick-add-drawer__sizes-list';
    sizes.removeAttribute('data-sizes-overflow');

    // En el drawer entran todos los talles: los ocultos se revelan y el chip
    // "+N" sobra.
    sizes.querySelectorAll(this.selectors.hiddenSize).forEach((size) => {
      size.style.display = '';
      size.removeAttribute('data-sizes-hidden');
    });
    sizes.querySelectorAll(this.selectors.moreToggle).forEach((toggle) => toggle.remove());

    this.querySelector(this.selectors.sizes).replaceChildren(sizes);

    const title = card.querySelector(this.selectors.cardTitle);
    this.querySelector(this.selectors.title).textContent = title ? title.textContent.trim() : '';

    const price = card.querySelector(this.selectors.cardPrice);
    this.querySelector(this.selectors.price).innerHTML = price ? price.outerHTML : '';

    return true;
  }
}
customElements.define('quick-add-drawer', QuickAddDrawer);

// Delegado en document: los filtros y la paginación AJAX re-renderizan la
// grilla, y ModalComponent bindea sus [aria-controls] una sola vez.
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-quick-add-mobile]');
  if (!button) return;

  event.preventDefault();

  const variantId = button.getAttribute('data-quick-add-variant');
  if (variantId) {
    window.simpleAddToCart(Number(variantId), event);
    return;
  }

  const drawer = document.getElementById('QuickAddDrawer');
  const card = button.closest('.product-card');
  const url = button.getAttribute('data-quick-add-url');

  if (drawer && card && typeof drawer.populate === 'function' && drawer.populate(card)) {
    drawer.show(button);
  } else if (url) {
    window.location.href = url;
  }
});
